import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "g3",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": "Defeat the boss.",
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawn"}),
                ]
            },
            ...PlotScripts.EncounterVictories({"encounterKeys": [1, 2, 3, 4], "spotTag": "spawn", "nextURL": "/games/war"}),
            PlotScripts.ChapterFailure(),
            {
                "type": "condition",
                "condition": function(stage) {
                    return stage.currentEncounterKey == "1"
                        && Zone.isInBounds(stage.encounters["1"].zone, stage.units["boss"].position)
                        && stage.units["boss"].health <= stage.units["boss"].maxhealth * (3/4)
                        && stage.units["boss"].isDead != true
                        && stage.turn.number > 0
                },
                "events": [
                    PlotSteps.Dialogue({"text": "THE WOUNDED MONSTER HAS RETREATED."}),
                    PlotSteps.CloseDialogue(),
                    PlotSteps.MoveUnitToSpot({"unitKey": "boss", "spotTag": "monster2"})
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return stage.currentEncounterKey == "2"
                        && Zone.isInBounds(stage.encounters["2"].zone, stage.units["boss"].position)
                        && stage.units["boss"].health <= stage.units["boss"].maxhealth * (1/2)
                        && stage.units["boss"].isDead != true
                        && stage.turn.number > 0
                },
                "events": [
                    PlotSteps.Dialogue({"text": "THE BLOODIED MONSTER HAS RETREATED."}),
                    PlotSteps.CloseDialogue(),
                    PlotSteps.MoveUnitToSpot({"unitKey": "boss", "spotTag": "monster3"})
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return stage.currentEncounterKey == "3"
                        && Zone.isInBounds(stage.encounters["3"].zone, stage.units["boss"].position)
                        && stage.units["boss"].health <= stage.units["boss"].maxhealth * (1/4)
                        && stage.units["boss"].isDead != true
                        && stage.turn.number > 0
                },
                "events": [
                    PlotSteps.Dialogue({"text": "THE MONSTER ON DEATH'S DOOR HAS RETREATED."}),
                    PlotSteps.CloseDialogue(),
                    PlotSteps.MoveUnitToSpot({"unitKey": "boss", "spotTag": "monster4"})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.units["boss"].isDead == true
                },
                "events": [
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war")},
                ]
            },
        ]
    },
}
